import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-input-search',
    templateUrl: './input-search.component.html',
    styleUrl: './input-search.component.scss',
    standalone: false
})
export class InputSearchComponent<T> {
    @Input() options: T[] = [];
    @Input() placeholderInput: string = '';
    @Input() allowNavigation: boolean = false;
    @Input() optionMatches: T;
    @Input() isClearForm: boolean = false;
  
    @Output() selectionChange = new EventEmitter<any[]>(); 
    @Output() searchChange = new EventEmitter<string>();

    searchQuery: string = '';
    filteredOptions: T[] = [];
    selectedItem: any = null;

    dropDownVisible: boolean = false;
  
    customerId: string = '';

    constructor(private eRef: ElementRef, private router: Router, private route: ActivatedRoute) { 
      this.customerId = this.route.snapshot.queryParams['customerId'];
    } 

    ngOnChanges() {
      if (this.isClearForm) {
        this.searchQuery = '';
        console.log(this.searchQuery);
        
      } 
      this.filteredOptions = this.options;
      this.getMatchesInSearch(); 
    }

  
    filterOptions() {
      this.searchChange.emit(this.searchQuery);
    }
  
    selectItem(item: any) {
      this.searchQuery = ''
      this.filterOptions();
      this.selectionChange.emit(item.id);
      setTimeout(() => this.dropDownVisible = false);
    }
    
    dropDownOpen() {
      this.dropDownVisible = !this.dropDownVisible;
    }

    @HostListener('document:click', ['$event'])
    dropDownClose(event: Event) {
      if (!this.eRef.nativeElement.contains(event.target)) {
        this.dropDownVisible = false;
      }
    }
  
    goToPage(path: string, item: any) {
      if (this.allowNavigation) this.router.navigate([path]);
      this.selectItem(item)
    }
  
  matchesMap: Record<string, string[]> = {};

  getMatchesInSearch() {
    const translationMap: Record<string, string> = {
      phone: "Телефон",
      email: "Email",
      address: "Адреса",
    };

    this.matchesMap = {}; 

    this.filteredOptions.forEach((option: any) => {
      if (option.matches) {
        const customMatch = String(option.matches.custom || "").toLowerCase(); 

        this.matchesMap[option.id] = Object.entries(option.matches)
          .filter(([key]) => key in translationMap)
          .map(([key, value]) => {
            let highlightedValue = String(value); 

            if (customMatch && highlightedValue.toLowerCase().includes(customMatch)) {
              const regex = new RegExp(`(${customMatch})`, "gi");
              highlightedValue = highlightedValue.replace(regex, `<span class="highlight">$1</span>`);
            }

            return `${translationMap[key] || key}: ${highlightedValue}`;
          });
      }
    });

    console.log(this.matchesMap);
  }



}
